<template>
  <div class="register">
    <div class="fm">
      <div class="item">
        <span>手机号</span>
        <input type="tel" placeholder="请输入登录账户" maxlength="11" v-model="mobile">
      </div>
      <p class="err">{{phoneMsg}}</p>
      <div class="item">
        <span>图形验证码</span>
        <input type="text" placeholder="请输入图形验证码" v-model="vxOpenId">
      </div>
      <p class="err">{{imgMsg}}</p>
      <div class="pic">
        <img :src="codeImg" alt="">
        <div class="mathCode">
          <p>请把左边验证码输入框中</p>
          <p class="refresh" @click="getCode">看不清，换一张</p>
        </div>
      </div>
      <div class="item">
        <span>验证码</span>
        <input type="text" placeholder="请输入验证码" v-model="code">
        <button :disabled="!rightPhone" class="codeBtn" :class="{right: rightPhone}" @click="send">{{computeTime ? `${computeTime}秒后重新获取` : '获取验证码'}}</button>
      </div>
      <p class="err">{{codeMsg}}</p>
      <div class="item">
        <span>密码</span>
        <input type="text" placeholder="请输入密码" v-model="passWord" v-if="bool">
        <input type="password" placeholder="请输入密码" v-model="passWord" v-else>
        <img src="../../assets/images/login/close.png" alt="" @click="open" v-if="bool">
        <img src="../../assets/images/login/open.png" alt="" @click="open" v-else>
      </div>
      <p class="err">{{pwdMsg}}</p>
      <div class="item">
        <span>确认密码</span>
        <input type="text" placeholder="请确认密码" v-model="pwd2" v-if="bool2">
        <input type="password" placeholder="请确认密码" v-model="pwd2" v-else>
        <img src="../../assets/images/login/close.png" alt="" @click="open2" v-if="bool2">
        <img src="../../assets/images/login/open.png" alt="" @click="open2" v-else>
      </div>
      <p class="err">{{pwdMsg2}}</p>
      <div class="item">
        <span>邀请码</span>
        <input type="text" placeholder="请输入邀请码" v-model="invitationCode">
      </div>
      <div class="deal">
        <input type="checkbox" id="checkbox">
        <p>
          我已同意并阅读
          <router-link :to="{name: 'RichText', query: {code: '019'}}"> <span>《一线快递用户协议》</span></router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {phone, pwd} from '../../utils/phone'
import {reqSend} from '../../api/index'
export default {
  data () {
    return {
      codeImg: '',
      mobile: '', // 手机号
      vxOpenId: '', // 图形验证码
      code: '', // 验证码
      passWord: '', // 新密码
      pwd2: '', // 确认密码
      invitationCode: '', // 邀请码

      phoneMsg: '', // 错误手机提示
      imgMsg: '',  //  图形验证码错误提示
      codeMsg: '',  //  验证码错误提示
      pwdMsg: '',  //  密码错误提示
      pwdMsg2: '',  //  再次密码错误提示
      inviMsg: '', // 邀请码错误提示
      computeTime:0 , // 计时时间
      bool: false,
      bool2: false
    }
  },
  created() {
    this.getCode()
  },
  methods: {
    //获取验证码
    getCode () {
      this.codeImg = 'http://app.yixian-express.com/api/pictureCode/out?'+Math.random()
    },
    //发送验证码
    send () {
      if(this.vxOpenId){
        this.imgMsg = ''
        if(!this.computeTime){
          //  异步发送验证码
          const data = `?mobile=${this.mobile}&type=REGISTER&code=${this.vxOpenId}`
          reqSend (data).then(res => {
            if(res.code === 200){
              this.computeTime = 60
              const timer = setInterval(() => {
                this.computeTime --
                if(this.computeTime <= 0){
                  clearInterval(timer)
                }
              },1000)
            }else if(res.code === 500){
              this.$message({
                type:'error',
                message:res.data.errMsg
              })
            }
          })
        }
      }else{
        this.imgMsg = '请先输入图形验证码'
      }

    },
    // 校验信息是否正确
    verify() {
      const {mobile, vxOpenId, code, passWord, pwd2, invitationCode} = this
      if(!mobile){
        this.phoneMsg = '手机号不能为空'
        return false
      }
      this.phoneMsg = phone(mobile)
      if(!vxOpenId){
        this.imgMsg = '图形验证码不能为空'
        return false
      }else{
        this.imgMsg = ''
      }
      if(!code){
        this.codeMsg = '验证码不能为空'
        return false
      }else{
        this.codeMsg = ''
      }
      if(!passWord){
        this.pwdMsg = '密码不能为空'
        return false
      }
      this.pwdMsg = pwd(passWord)
      if(passWord !== pwd2){
        this.pwdMsg2 = '两次密码不一致，请重试'
        this.pwd2 = ''
        return false
      }else{
        this.pwdMsg2 = ''
      }
      const bool = document.getElementById('checkbox').checked
      if(bool){
        let data = {}
        if(this.invitationCode){
           data ={
            mobile,
            code,
            passWord,
            invitationCode
          }
        }else{
           data ={
            mobile,
            code,
            passWord
          }
        }
        this.$emit('memberRegister', data)
      }else{
        this.$message({
          message:'请阅读协议并同意',
          type:'error'
        })
      }


    },
    open () {
      this.bool = !this.bool
    },
    open2 () {
      this.bool2 = !this.bool2
    }
  },
  computed: {
    //监听手机号是否正确
    rightPhone () {
      return /^1[3456789]\d{9}$/.test(this.mobile)
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Login/Register.vue